<template>
  <div id="TimeSeries" ref="wrapper">
    <div class="header">
      <div>Showing data from: {{ date }}</div>
      <div class="mt-4">
        <v-select
          :items="zoomOpts"
          v-model="timePeriod"
          item-text="name"
          item-value="id"
          return-object
          label="Zoom to"
          hide-details
          @change="zoomTo"
        />
      </div>
    </div>
    <!-- Graph -->
    <div id="time-series"></div>
    <div style="display: flex; justify-content: space-between; width: 90%;">
      <div id="seriesType" >
        <span>Volume</span>
        <v-switch
          class="ml-2"
          color="primary"
          v-model="seriesType"
          ></v-switch>
        <span>File</span>
      </div>
      <div id="seriesType" >
        <span>Fill Gaps</span>
        <v-switch
          class="ml-2"
          color="primary"
          v-model="fillGap"
          ></v-switch>
        <span>Raw</span>
      </div>
    </div>
    <!-- Graph -->
    <div class="graph-wrap">
      <div id="leftpanel"></div>
      <div id="stackedArea"></div>
    </div>

    <div class="legend">
      <div class="item" v-for="item in legend" :key="item.name">
        <div class="bar" :style="{background: item.color}"></div>
        <div>{{item.name}}</div>
      </div>
    </div>
    <div class="table" v-if="timePeriod.id != undefined && timePeriod.id != 4">
      <v-data-table
        :headers="header"
        :items="items"
        class="light-table"
        hide-default-footer
      >
        <template v-slot:body="{ items }">
          <tbody v-if="items.length">
            <tr v-for="item in items" :key="item.entity_id">
              <td>{{ item.type || '-' }}</td>
              <td>{{ toScientificNotation(items,item.period1) }}</td>
              <td>{{ toScientificNotation(items,item.period2) }}</td>
              <td class="d-flex justify-start align-center pa-0">
                <div>
                  <div v-if="item.period2 - item.period1 > 0" style="width:30px">&#9650;</div>
                  <div v-if="item.period2 - item.period1 < 0" style="width:30px">&#9660;</div>
                </div>
                <div :class="{ 'adjust': Math.abs(item.period2 - item.period1) == 0 }">{{ toScientificNotation(items,Math.abs(item.period2 - item.period1))  }}</div>
              </td>
              <td>
                <div class="d-flex justify-start align-center">
                  <div>
                    <div v-if="item.period2 - item.period1 > 0">+</div>
                    <div v-if="item.period2 - item.period1 < 0">-</div>
                  </div>
                  <div>{{getPercentageValue(item.period1,item.period2)}}%</div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import * as d3s from 'd3'
import moment from 'moment'
import _ from 'underscore'
import { mapGetters } from 'vuex'
import { convert, numberWithCommas, dateDiffDays } from '@/utils/main_helper'
const showFuture = process.env.VUE_APP_SHOW_FUTURE == 'true'

export default {
  name: 'TimeSeries',
  props: ['discoveryId', 'windowWidth'],
  computed: {
    ...mapGetters({
      currentOrganization: 'currentOrganization',
      getTimeSeries: 'discoveryServices/getTimeSeries'
    }),
    header () {
      return [
        { text: this.seriesType ? 'Files' : 'Volume', value: 'type', show: true, sortable: false },
        { text: this.date.split('-')[0], value: 'period1', show: true, width: '20%', sortable: false },
        { text: this.date.split('-')[1], value: 'period2', show: true, width: '20%', sortable: false },
        { text: 'Change', value: 'change', show: true, width: '20%', sortable: false },
        { text: 'Percent Change', value: 'percent', show: true, width: '20%', sortable: false }
      ]
    },
    items () {
      if (this.timePeriod && this.customDateRange.length, Object.keys(this.getTimeSeries).length) {
        const first = this.getTimeSeries[moment(this.customDateRange[0]).format('YYYY-MM-DD')] || this.getTimeSeries[Object.keys(this.getTimeSeries)[0]]
        const second = this.getTimeSeries[moment(this.customDateRange[1]).format('YYYY-MM-DD')]
        const items = []
        items.push({ type: 'Business Continuity', period1: first.business_continuity[this.seriesType ? 'count' : 'size'], period2: second.business_continuity[this.seriesType ? 'count' : 'size'] })
        items.push({ type: 'Manage & Govern', period1: first.manage_govern[this.seriesType ? 'count' : 'size'], period2: second.manage_govern[this.seriesType ? 'count' : 'size'] })
        items.push({ type: 'Risk Management', period1: first.risk_management[this.seriesType ? 'count' : 'size'], period2: second.risk_management[this.seriesType ? 'count' : 'size'] })
        return items
      }
      return []
    }
  },
  mounted () {
    this.timePeriod = this.zoomOpts[5]
    this.render()
  },
  data () {
    return {
      seriesType: true,
      zoomOpts: [
        { id: 0, name: 'Year' },
        { id: 1, name: 'Quarter' },
        { id: 2, name: 'Month' },
        { id: 3, name: 'Week' },
        { id: 4, name: 'Reset' },
        { id: 5, name: 'Custom' }
      ],
      timePeriod: '',
      date: '',
      legend: [
        { name: 'Business Continuity', color: '#CEE2EE' },
        { name: 'Manage & Govern', color: '#A2B7C1' },
        { name: 'Risk Mangement', color: '#88979F' }
      ],
      update: false,
      customDateRange: [],
      previousState: [],
      Yscale_max: 0,
      fillGap: true
    }
  },
  methods: {
    render () {
      if (this.update) {
        d3s.select('#stackedArea svg').remove(); d3s.select('#stackedArea svg').selectAll('*').remove()
        d3s.select('#leftpanel svg').remove(); d3s.select('#leftpanel svg').selectAll('*').remove()
        d3s.select('svg').remove(); d3s.select('svg').selectAll('*').remove()
        this.update = false
      }
      if (!Object.keys(this.getTimeSeries).length) return
      var optwidth = this.windowWidth
      var optheight = 120
      var self = this
      // Combine the months and count array to make "data"
      var dataset = []
      Object.keys(this.getTimeSeries).forEach(time => {
        const type = this.seriesType ? 'count' : 'size'
        const count = this.getTimeSeries[time].business_continuity[type] + this.getTimeSeries[time].risk_management[type] + this.getTimeSeries[time].manage_govern[type]
        var obj = {
          count: this.seriesType ? count : this.convertToGB(count),
          time: time,
          bcData: this.seriesType ? this.getTimeSeries[time].business_continuity.count : this.convertToGB(this.getTimeSeries[time].business_continuity.size),
          rmData: this.seriesType ? this.getTimeSeries[time].risk_management.count : this.convertToGB(this.getTimeSeries[time].risk_management.size),
          mgData: this.seriesType ? this.getTimeSeries[time].manage_govern.count : this.convertToGB(this.getTimeSeries[time].manage_govern.size),
          data: 0
        }
        if (!this.fillGap) {
          if (obj.count !== 0) {
            dataset.push(obj)
          }
        } else {
          dataset.push(obj)
        }
      })
      // format time as a date
      dataset.forEach(function (d) {
        d.time = d3.time.format('%Y-%m-%d').parse(d.time)
      })

      // sort dataset by time
      dataset.sort(function (x, y) {
        return d3.ascending(x.time, y.time)
      })

      var margin	= { top: 20, right: 30, bottom: 5, left: 20 }
      var width	= optwidth - margin.left - margin.right
      var height	= optheight - margin.top - margin.bottom

      var margin_context = { top: 20, right: 30, bottom: 20, left: 20 }
      var height_context = optheight - margin_context.top - margin_context.bottom

      // the date range of available data:
      var dataXrange = d3.extent(dataset, function (d) { return d.time })
      var dataYrange = [0, d3.max(dataset, function (d) { return d.count }) + (10 / 100) * d3.max(dataset, function (d) { return d.count })]

      // maximum date range allowed to display
      var mindate = dataXrange[0] // use the range of the data
      var maxdate = dataXrange[1]

      if (!this.customDateRange.length) {
        this.customDateRange = [mindate, maxdate]
      }

      var DateFormat = d3.time.format('%d %b %Y')

      var dynamicDateFormat = timeFormat([
        [d3.time.format('%Y'), function () { return true }], // <-- how to display when Jan 1 YYYY
        [d3.time.format('%b %Y'), function (d) { return d.getMonth() }],
        [function () { return '' }, function (d) { return d.getDate() != 1 }]
      ])

      var x = d3.time.scale()
        .range([0, (width)])
        .domain(dataXrange)

      var y = d3.scale.linear()
        .range([height, 0])
        .domain(dataYrange)

      var x2 = d3.time.scale()
        .range([0, width])
        .domain([mindate, maxdate])

      var y2 = d3.scale.linear()
        .range([height_context, 0])
        .domain(y.domain())

      var xAxis_context = d3.svg.axis()
        .scale(x2)
        .orient('bottom')
        .ticks(customTickFunction)
        .tickFormat(dynamicDateFormat)

      var area_context = d3s.area()
        .curve(d3s.curveMonotoneX)
        .x(function (d) { return x2(d.time) })
        .y0((height_context))
        .y1(function (d) { return y2(d.count) })

      var line_context = d3s.line()
        .curve(d3s.curveMonotoneX)
        .x(function (d) { return x2(d.time) })
        .y(function (d) { return y2(d.count) })

      var brush = d3.svg.brush()
        .x(x2)
        .extent([...this.previousState])
        .on('brush', brushed)
        .on('brushend', brushend)

      var zoom = d3.behavior.zoom()
        .on('zoom', draw)
        .on('zoomend', brushend)

      /*
      * ========================================================================
      *  Define the SVG area ("vis") and append all the layers
      * ========================================================================
      */

      var vis = d3.select('#time-series').append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .attr('class', 'metric-chart') // CB -- "line-chart" -- CB //

      vis.append('defs').append('clipPath')
        .attr('id', 'clip')
        .append('rect')
        .attr('width', width)
        .attr('height', height)
      // clipPath is used to keep line and area from moving outside of plot area when user zooms/scrolls/brushes

      var context = vis.append('g')
        .attr('class', 'context')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
        .call(draw)

      // === current date range text & zoom buttons === //

      var display_range_group = vis.append('g')
        .attr('id', 'buttons_group')
        .attr('transform', 'translate(' + 0 + ',' + 0 + ')')

      context.append('path')
        .datum(dataset)
        .attr('class', 'area')
        .attr('d', area_context)

      context.append('path')
        .datum(dataset)
        .attr('class', 'line')
        .attr('d', line_context)

      context.append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + height_context + ')')
        .call(xAxis_context)

      /* === brush (part of context chart)  === */

      var brushg = context.append('g')
        .attr('class', 'x brush')
        .call(brush)

      brushg.selectAll('.extent')
        .attr('y', -6)
        .attr('height', height_context + 8)

      brushg.selectAll('.resize')
        .append('rect')
        .attr('class', 'handle-mini')
        .attr('transform', (d) => d === 'w' ? 'translate(-3,14)' : 'translate(-6,14)')
        .attr('rx', 8)
        .attr('ry', 8)
        .attr('height', (height_context / 2))
        .attr('width', 10)

      function timeFormat (formats) {
        return function (date) {
          var i = formats.length - 1; var f = formats[i]
          while (!f[1](date)) f = formats[--i]
          return f[0](date)
        }
      };

      function customTickFunction (t0, t1, dt) {
        var labelSize = 42 //
        var maxTotalLabels = Math.floor(width / labelSize)

        function step (date, offset) {
          date.setMonth(date.getMonth() + offset)
        }

        var time = d3.time.month.ceil(t0); var times = []; var monthFactors = [1, 3, 4, 12]

        while (time < t1) times.push(new Date(+time)), step(time, 1)
        var timesCopy = times
        var i
        for (i = 0; times.length > maxTotalLabels; i++) {
          times = _.filter(timesCopy, function (d) {
            return (d.getMonth()) % monthFactors[i] == 0
          })
        }

        return times
      };

      // === brush and zoom functions ===
      function brushed () {
        x.domain(brush.empty() ? x2.domain() : brush.extent())
        self.previousState = brush.extent()
        if (self.previousState.length > 0) {
          self.getMaxiumCount(dataset, self.previousState)
        }
        self.customDateRange = brush.extent()
        self.checkCustom()
        zoom.x(x)
        updateDisplayDates()
        setYdomain()
        self.renderStacked(dataset, self.windowWidth, brush, true)
      };

      function draw () {
        setYdomain()
        brush.extent(self.previousState.length > 0 ? self.previousState : x.domain())
        vis.select('.brush').call(brush)
        // and update the text showing range of dates.
        updateDisplayDates()
      };

      function brushend () {
      // when brush stops moving:
        // check whether chart was scrolled out of bounds and fix,
        var b = brush.extent()
        var out_of_bounds = brush.extent().some(function (e) { return e <= mindate | e >= maxdate })
        if (out_of_bounds) { b = moveInBounds(b) };
        self.renderStacked(dataset, self.windowWidth, brush, true)
      };

      function updateDisplayDates () {
        var b = brush.extent()
        // update the text that shows the range of displayed dates
        var localBrushDateStart = (brush.empty()) ? DateFormat(dataXrange[0]) : DateFormat(b[0])
        var localBrushDateEnd = (brush.empty()) ? DateFormat(dataXrange[1]) : DateFormat(b[1])
        self.$emit('setTimeSeriesDates', b)
        self.date = localBrushDateStart == localBrushDateEnd ? localBrushDateStart : localBrushDateStart + ' - ' + localBrushDateEnd
      };

      function moveInBounds (b) {
      // move back to boundaries if user pans outside min and max date.

        var ms_in_year = 31536000000
        var brush_start_new
        var brush_end_new

        if (b[0] < mindate) { brush_start_new = mindate } else if (b[0] > maxdate) { brush_start_new = new Date(maxdate.getTime() - ms_in_year) } else { brush_start_new = b[0] };

        if (b[1] > maxdate) { brush_end_new = maxdate } else if (b[1] < mindate) { brush_end_new = new Date(mindate.getTime() + ms_in_year) } else { brush_end_new = b[1] };

        brush.extent([brush_start_new, brush_end_new])

        brush(d3.select('.brush').transition())
        brushed()
        draw()
        self.showHandle()
        return (brush.extent())
      };

      function setYdomain () {
      // this function dynamically changes the y-axis to fit the data in focus

        // get the min and max date in focus
        var xleft = new Date(x.domain()[0])
        var xright = new Date(x.domain()[1])

        // a function that finds the nearest point to the right of a point
        var bisectDate = d3.bisector(function (d) { return d.time }).right

        // get the y value of the line at the left edge of view port:
        var iL = bisectDate(dataset, xleft)

        if (dataset[iL] !== undefined && dataset[iL - 1] !== undefined) {
          var left_dateBefore = dataset[iL - 1].time
          var left_dateAfter = dataset[iL].time

          var intfun = d3.interpolateNumber(dataset[iL - 1].count, dataset[iL].count)
          var yleft = intfun((xleft - left_dateBefore) / (left_dateAfter - left_dateBefore))
        } else {
          var yleft = 0
        }

        // get the x value of the line at the right edge of view port:
        var iR = bisectDate(dataset, xright)

        if (dataset[iR] !== undefined && dataset[iR - 1] !== undefined) {
          var right_dateBefore = dataset[iR - 1].time
          var right_dateAfter = dataset[iR].time

          var intfun = d3.interpolateNumber(dataset[iR - 1].count, dataset[iR].count)
          var yright = intfun((xright - right_dateBefore) / (right_dateAfter - right_dateBefore))
        } else {
          var yright = 0
        }

        // get the y values of all the actual data points that are in view
        var dataSubset = dataset.filter(function (d) { return d.time >= xleft && d.time <= xright })
        var countSubset = []
        dataSubset.map(function (d) { countSubset.push(d.count) })

        // add the edge values of the line to the array of counts in view, get the max y;
        countSubset.push(yleft)
        countSubset.push(yright)
        var ymax_new = d3.max(countSubset)

        if (ymax_new == 0) {
          ymax_new = dataYrange[1]
        }

        // reset and redraw the yaxis
        y.domain([0, ymax_new * 1.05])
        // focus.select(".y.axis").call(yAxis);
      };

      this.scaleDate = (d, i) => {
        // action for buttons that scale focus to certain time interval
        var b = brush.extent()
        var interval_ms
        var brush_end_new
        var brush_start_new

        if (d == 'Year') {
          interval_ms = 31536000000
        } else if (d == 'Quarter') {
          interval_ms = 31536000000 / 4
        } else if (d == 'Month') {
          interval_ms = 2592000000
        } else if (d == 'Week') {
          interval_ms = 31536000000 / 52.1429
        }

        if (d == 'Year' | d == 'Quarter' | d == 'Month' | d == 'Week') {
          if ((maxdate.getTime() - b[1].getTime()) < interval_ms) {
            // if brush is too far to the right that increasing the right-hand brush boundary would make the chart go out of bounds....
            brush_start_new = new Date(maxdate.getTime() - interval_ms) // ...then decrease the left-hand brush boundary...
            brush_end_new = maxdate // ...and set the right-hand brush boundary to the maxiumum limit.
          } else {
            // otherwise, increase the right-hand brush boundary.
            brush_start_new = b[0]
            brush_end_new = new Date(b[0].getTime() + interval_ms)
          };
        } else if (d == 'Reset') {
          brush_start_new = dataXrange[0]
          brush_end_new = dataXrange[1]
        } else {
          brush_start_new = b[0]
          brush_end_new = b[1]
        };

        brush.extent([brush_start_new, brush_end_new])

        // now draw the brush to match our extent
        brush(d3.select('.brush').transition())
        // now fire the brushstart, brushmove, and brushend events
        brush.event(d3.select('.brush').transition())
      }
      this.renderStacked(dataset, this.windowWidth, brush, false)
      self.showHandle()
    },
    convertToGB (value) {
      return (value / (1000 * 1000 * 1000))
    },
    renderStacked (data, widths, brush, update) {
      if (update) {
        d3s.select('#stackedArea svg').remove(); d3s.select('#stackedArea svg').selectAll('*').remove()
      }
      const color = ['#88979F', '#88979F', '#A2B7C1', '#A2B7C1', '#CEE2EE', '#CEE2EE']
      // Create SVG and padding for the chart
      var svg = d3s.select('#stackedArea')
        .append('svg')
        .attr('height', 450)
        .attr('width', widths)

      const strokeWidth = 1.5
      const margin = { top: 0, bottom: 50, left: 70, right: 50 }
      const chart = svg.append('g').attr('transform', `translate(${margin.left},0)`)
      const width = +svg.attr('width') - margin.left - margin.right - strokeWidth * 2
      const height = +svg.attr('height') - margin.top - margin.bottom
      const grp = chart
        .append('g')
        .attr('transform', `translate(0, -${margin.top})`)

      // Create stack
      const stack = d3s.stack().keys(['rmData', 'data', 'mgData', 'data', 'bcData', 'data'])
      const stackedValues = stack(data)
      const stackedData = []
      // Copy the stack offsets back into the data.
      stackedValues.forEach((layer, index) => {
        const currentStack = []
        layer.forEach((d, i) => {
          currentStack.push({
            values: d,
            time: data[i].time
          })
        })
        stackedData.push(currentStack)
      })

      // Create scales
      const yScale = d3s
        .scaleLinear()
        .range([height, 0])
        .domain(this.onBrushedYscalesValues(stackedValues, data))

      const xScale = d3s
        .scaleLinear()
        .range([0, width])
        .domain(this.onBrushedXscalesValues(data, brush))
      const area = d3s
        .area()
        .x(dataPoint => xScale(dataPoint.time))
        .y0(dataPoint => yScale(dataPoint.values[0]))
        .y1(dataPoint => yScale(dataPoint.values[1]))
        .curve(d3s.curveMonotoneX)

      const series = grp
        .selectAll('.series')
        .data(stackedData)
        .enter()
        .append('g')
        .attr('class', 'series')

      series
        .append('path')
        .attr('transform', 'translate(0,0)')
        .style('fill', (d, i) => color[i])
        .attr('stroke', (d, i) => color[i])
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', strokeWidth)
        .attr('class', 'seriesArea')
        .attr('d', d => area(d))

      chart.append('rect')
        .attr('width', 70)
        .attr('height', height + 3)
        .attr('x', '-70')
        .attr('y', '0')
        .style('fill', '#fff')

      chart.append('rect')
        .attr('width', 70)
        .attr('height', height + 3)
        .attr('x', width + 5)
        .attr('y', '0')
        .style('fill', '#fff')

      chart.append('rect')
        .attr('width', width + 120)
        .attr('height', 51)
        .attr('x', '-70')
        .attr('y', '400')
        .style('fill', '#fff')

      var ticksLabels = []
      chart
        .append('g')
        .attr('transform', `translate(0,${height})`)
        .call(
          d3s.axisBottom(xScale)
            .ticks(this.getTicks())
            .tickFormat((d) => {
              const label = this.getXscalesValues(d)
              const result = ticksLabels.includes(label) ? null : label
              ticksLabels.push(label) // avoid duplicate labels if any
              return result
            })
        )

      // Add the Y Axis
      chart
        .append('g')
        .attr('transform', 'translate(0, 0)')
        .call(d3s.axisLeft(yScale))

      chart.append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - margin.left + (this.seriesType ? 10 : 0))
        .attr('x', 0 - (450 / 2))
        .attr('dy', '1em')
        .style('text-anchor', 'middle')
        .style('color', '#212338')
        .text(this.seriesType ? 'File Count' : 'Volume (GB)')

      /// ////// Hover line ///////////

      var mouseG = grp.append('g')
        .attr('class', 'mouse-over-effects')
        .attr('transform', 'translate(0,0)')

      mouseG.append('path') // this is the black vertical line to follow mouse
        .attr('class', 'mouse-line')
        .style('stroke', 'black')
        .style('stroke-width', '1px')
        .style('opacity', '0')

      var seriesArea = document.getElementsByClassName('seriesArea')

      var mousePerLine = mouseG.selectAll('.mouse-per-line')
        .data(stackedData)
        .enter()
        .append('g')
        .attr('class', 'mouse-per-line')

      mousePerLine.append('circle')
        .attr('r', 7)
        .style('stroke', 'black')
        .style('fill', 'none')
        .style('stroke-width', '1px')
        .style('opacity', '0')

      mousePerLine.append('text')
        .attr('transform', 'translate(10,3)')

      mouseG.append('svg:rect') // append a rect to catch mouse movements on canvas
        .attr('width', width) // can't catch mouse events on a g element
        .attr('height', height)
        .attr('fill', 'none')
        .attr('pointer-events', 'all')
        .on('mouseout', function () { // on mouse out hide line, circles and text
          d3.select('.mouse-line')
            .style('opacity', '0')
          d3.selectAll('.mouse-per-line circle')
            .style('opacity', '0')
          d3.selectAll('.mouse-per-line text')
            .style('opacity', '0')
        })
        .on('mouseover', function () { // on mouse in show line, circles and text
          d3.select('.mouse-line')
            .style('opacity', '1')
          d3.selectAll('.mouse-per-line circle')
            .style('opacity', '1')
          d3.selectAll('.mouse-per-line text')
            .style('opacity', '1')
        })
        /// check from here
        .on('mousemove', function () { // mouse moving over canvas
          var mouse = d3s.mouse(this)
          d3.select('.mouse-line')
            .attr('d', function () {
              var d = 'M' + mouse[0] + ',' + (height + 5)
              d += ' ' + mouse[0] + ',' + 0
              return d
            })
          var arr = []
          let positions = []
          d3.selectAll('.mouse-per-line')
            .attr('transform', function (d, i) {
              const pos = findPosition(mouse, i)
              positions.push(pos)
              d3.select(this).select('text')
                .text(Math.round(yScale.invert(pos.y)))

              arr.push(yScale.invert(pos.y))
              return 'translate(' + mouse[0] + ',' + pos.y + ')'
            })
            .style('opacity', function (d, i) {
              const pos = positions[i]
              return yScale.invert(pos.y) === 0 ? '0' : '1'
            })
          positions = []
          var maxValue = Math.max.apply(Math, arr)
          d3.select('.mouse-line')
            .attr('d', function () {
              var d = 'M' + mouse[0] + ',' + yScale(maxValue)
              d += ' ' + mouse[0] + ',' + (height + 5)
              return d
            })
        })
      function findPosition (mouse, i) {
        var beginning = 0
        var end = seriesArea[i].getTotalLength()
        var target = null
        while (true) {
          target = Math.floor((beginning + end) / 2)
          var pos = seriesArea[i].getPointAtLength(target)
          if ((target === end || target === beginning) && pos.x !== mouse[0]) {
            break
          }
          if (pos.x > mouse[0]) end = target
          else if (pos.x < mouse[0]) beginning = target
          else break // position found
        }
        return pos
      }
    },
    zoomTo () {
      this.scaleDate(this.timePeriod.name, this.timePeriod.id)
    },
    checkCustom () {
      const days = Math.ceil(moment.duration(moment(this.customDateRange[1]).diff(this.customDateRange[0])).asDays())
      this.timePeriod = this.zoomOpts[this.getTimePeriodId(days)]
    },
    getTimePeriodId (days) {
      if (days == 365) return 0
      else if (days == 92) return 1
      else if (days == 30) return 2
      else if (days == 7) return 3
      else return 5
    },
    getAddTenPercent (number) {
      return number + (10 / 100 * number)
    },
    getPercentageValue (oldvalue, newvalue) {
      if (!oldvalue && !newvalue) return 0
      else if (!oldvalue && newvalue > 0) return 100
      const result = Math.abs((((oldvalue - newvalue) / oldvalue) * 100))
      return result >= 100 ? numberWithCommas(result.toFixed(0)) : result.toFixed(2)
    },
    toScientificNotation (items, value) {
      if (this.seriesType) return this.fileCountFormat(value)
      const period1 = Math.max.apply(Math, items.map(function (o) { return o.period1 }))
      const period2 = Math.max.apply(Math, items.map(function (o) { return o.period2 }))
      const period = period1 > period2 ? period1 : period2
      var maxUnit = convert(period, '', 1000)
      maxUnit = maxUnit.replace(/[^a-z]/gi, '')
      return this.toExponential(value, maxUnit)
    },
    toExponential (value, unit) {
      const marker = 1000
      const power = this.getUnitPower(unit)
      if (value == 0) return 0 + ' ' + (unit == 'B' ? 'GB' : unit + 'B')
      else if (power == 0) return value
      else if (this.isPowerNegative((value / Math.pow(marker, power)).toExponential(2))) {
        return (value / Math.pow(marker, power)).toFixed(3) + ' ' + (unit == 'B' ? 'GB' : unit + 'B')
      } else {
        return (value / Math.pow(marker, power)).toExponential(2) + ' ' + (unit == 'B' ? 'GB' : unit + 'B')
      }
    },
    fileCountFormat (x) {
      if (String((+x).toFixed()).length === 6) {
        return Math.floor(x / 1000) + 'K'
      } else if (String((+x).toFixed()).length >= 7 && String((+x).toFixed()).length < 10) {
        return Math.floor(x / 1000000) + 'M'
      } else if (String((+x).toFixed()).length > 9) {
        return Math.floor(x / 1000000000) + 'B'
      }
      return numberWithCommas(x)
    },
    getUnitPower (unit) {
      if (unit == 'T') return 4
      else if (unit == 'B') return 3
      else if (unit == 'M') return 2
      else if (unit == 'K') return 1
      else if (unit == '') return 0
    },
    isPowerNegative (value) {
      if (value.includes('+')) return (Number(value.split('+')[1]) == 0)
      else if (value.includes('-')) return (Number(value.split('-')[1]) < 3)
      else return false
    },
    getXscalesValues (timestamp) {
      var daysCount = dateDiffDays(this.customDateRange[0], this.customDateRange[1])
      if (daysCount < 30) {
        return moment(timestamp).format('DD-MMM')
      } else if (daysCount < 365) {
        return moment(timestamp).format('DD-MMM-YYYY')
      } else if (daysCount >= 365) {
        return moment(timestamp).format('YYYY')
      }
    },
    onBrushedXscalesValues (data, brush) {
      if (this.previousState.length > 0) {
        return this.previousState
      } else if (!brush || brush.empty()) {
        return d3s.extent(data, dataPoint => dataPoint.time)
      } else {
        return brush.extent()
      }
    },
    onBrushedYscalesValues (stackedValues, data) {
      if (this.previousState.length > 0) {
        this.getMaxiumCount(data, this.previousState)
        return [0, this.getAddTenPercent(this.Yscale_max) > 0 ? this.getAddTenPercent(this.Yscale_max) : NaN]
      } else {
        return [0, this.getAddTenPercent(d3s.max(stackedValues[stackedValues.length - 1], dp => dp[1]))]
      }
    },
    getMaxiumCount (value, previousState) {
      var j = value.filter(function (d) {
        return previousState[0] <= d.time && previousState[1] >= d.time
      })
      this.Yscale_max = Math.max.apply(Math, j.map(function (o) { return o.count }))
    },
    showHandle () {
      document.getElementsByClassName('resize')[0].style.display = 'block'
      document.getElementsByClassName('resize')[1].style.display = 'block'
    },
    getTicks () {
      var daysCount = dateDiffDays(this.customDateRange[0], this.customDateRange[1])
      return (daysCount < 9) ? daysCount : null
    }
  },
  watch: {
    getTimeSeries () {
      this.update = true
      this.customDateRange = []
      this.previousState = []
      this.render()
    },
    seriesType () {
      this.update = true
      this.timePeriod = this.zoomOpts[5]
      this.render()
    },
    fillGap () {
      this.update = true
      this.render()
    },
    currentOrganization () {
      this.timePeriod = ''
      this.customDateRange = []
      this.previousState = []
    }
  }
}
</script>

<style lang="scss">

#TimeSeries {
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    padding-top: 10px;
    padding-right: 12px;
  }
  #seriesType {
    display: flex;
    flex-direction: row;
    align-items: center;
  	padding: 0px 44px 0px 104px;
    font-weight: 500;
    .v-input--switch__track {
      color: #DBDBE0 !important;
      caret-color: #DBDBE0 !important;
    }
    .v-input--switch__thumb {
      color: #3aca56 !important;
      caret-color: #3aca56 !important;
    }
  }
  .legend {
    display: flex;
    flex-direction: row;
  	padding: 0px 44px 0px 104px;
    justify-content: center;
    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 25px;
      .bar {
        width: 120px;
        height: 15px;
        margin-right: 15px;
      }
    }
  }
  .table {
  	padding: 20px 150px 20px 104px;
  }
  .v-text-field {
    padding: 0px !important;
    margin: 0px !important
  }
}
.graph-wrap{
  display: flex;
  padding-left: 104px;
}

#leftpanel svg{
  font: 10px sans-serif;
}
#leftpanel path{
	fill: #E1E1EA; /* CB default, changed in each theme */
	opacity: 0.6;
}

#leftpanel .axis path,
.axis line {
  fill: none;
  stroke: #000;
  shape-rendering: crispEdges;
}
#leftpanel .brush .extent {
  stroke: #fff;
  fill-opacity: .125;
  shape-rendering: crispEdges;
}
#stackedArea {
	padding: 0;
}

#time-series .metric-chart text {
	fill: #565656;
	font-size: 9px;
	font-family: Helvetica, Arial, "sans serif";
}

#time-series .metric-chart text.no-data {
	font-size: 16px;
	font-weight: 100;
	fill:#d0d0d0;
}

#time-series .metric-chart rect.no-data {
	fill: #f5f5f5;
}

/* When there is data ...*/

/* CB: padding to display better on bl.ocks.org */
#time-series {
	padding: 0px 44px 0px 104px;
}

#time-series .metric-chart rect.plot-background{
	fill: white;
}

#time-series .metric-chart path.line {
	fill: none;
	stroke: #E1E1EA; /* default, changed in each theme */
	stroke-width: 1.5px;
	clip-path: url(#clip);
}

#time-series .metric-chart path.area {
	fill: #E1E1EA; /* CB default, changed in each theme */
	opacity: 0.6;
	clip-path: url(#clip);
}

#time-series .metric-chart .axis {
	shape-rendering: crispEdges;
}

#time-series .metric-chart .x.axis .domain{
	display:none;
}

#time-series .metric-chart .x.axis line {
	stroke: white;
	opacity: 0.4;
}

#time-series .metric-chart .context .x.axis line {
	display: none;
}

#time-series .metric-chart .y.axis .domain{
	display: none;
}

#time-series .metric-chart .y.axis.title{
	font-size: 13px;
	font-weight: 100;
}

#time-series .metric-chart .y.axis line {
	stroke: #565656;
	stroke-dasharray: 2,2;
	stroke-opacity: 0.3;
}

#time-series .metric-chart .brush .extent {
  fill-opacity: .07;
  shape-rendering: crispEdges;
  clip-path: url(#clip);
}

#time-series .metric-chart rect.pane {
	cursor: move;
	fill: none;
	pointer-events: all;
}
/* brush handles  */
#time-series .metric-chart .resize .handle {
	fill: #555;
}

/* brush handles  */
#leftpanel .resize .handle {
	fill: #555;
}

#time-series .metric-chart .resize .handle-mini {
	fill: #8E90A0;
    stroke-width: 1px;
    stroke: #555;
}

#leftpanel .resize .handle-mini {
	fill: #8E90A0;
    stroke-width: 1px;
    stroke: #555;
}

#time-series .metric-chart .resize .handle-mini:active,
#time-series .metric-chart .resize .handle-mini:focus,
#time-series .metric-chart .resize .handle-mini:hover {
	fill: #222;
}

#leftpanel .resize .handle-mini:active,
#leftpanel  .resize .handle-mini:focus,
#leftpanel  .resize .handle-mini:hover {
	fill: #222;
}
#time-series .metric-chart .scale_button {
	cursor: pointer;
}
#leftpanel .resize rect{
   visibility: visible !important;
   	fill: #8E90A0;
    stroke-width: 0.5px;
    stroke: #555;
    border-radius: 30px;
}

#time-series .metric-chart .scale_button rect {
	fill: #eaeaea;
}
#time-series .metric-chart .scale_button:hover text {
	fill: #417DD6;
	transition: all 0.1s cubic-bezier(.25,.8,.25,1);
}

#time-series .metric-chart text#displayDates  {
	font-weight: bold;
}
</style>
